<template>
  <component
    :is="tag"
    :to="to"
    :href="href"
    :type="tag === 'button' ? type : undefined"
    :target="isExternal ? '_blank' : undefined"
    :rel="isExternal ? 'noopener noreferrer' : undefined"
    :class="buttonClasses"
    :disabled="disabled"
  >
    <slot />
  </component>
</template>

<script setup>
import { computed } from 'vue'
import { RouterLink } from 'vue-router'

const props = defineProps({
  variant: {
    type: String,
    default: 'primary',
    validator: (v) => ['primary', 'secondary', 'outline', 'ghost-light', 'outline-light'].includes(v),
  },
  to: {
    type: [String, Object],
    default: null,
  },
  href: {
    type: String,
    default: null,
  },
  type: {
    type: String,
    default: 'button',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  block: {
    type: Boolean,
    default: false,
  },
})

const tag = computed(() => {
  if (props.to) return RouterLink
  if (props.href) return 'a'
  return 'button'
})

const isExternal = computed(
  () => Boolean(props.href && /^https?:\/\//i.test(props.href)),
)

const buttonClasses = computed(() => {
  const base = props.block ? 'w-full' : ''
  const variants = {
    primary: 'btn-primary',
    secondary: 'btn-secondary',
    outline: 'btn-outline',
    'ghost-light': 'btn-ghost-light',
    'outline-light': 'btn-outline-light',
  }
  return [
    base,
    variants[props.variant],
    props.disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
  ].join(' ')
})
</script>
